import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import PropTypes from 'prop-types';

const PagosTittle = ({ cargando }) => {
    if (cargando) {
        return <Skeleton height={60} className="mb-1" />;
    }

    return (
        <Card className="mb-1 p-2">
            <Row className="g-2 align-items-sm-center">
                <Col xs="auto">
                    <img src="/img/ordenes96.png" alt="connectCircle" height={30} />
                </Col>
                <Col>
                    <h5>Conciliación de pagos</h5>
                </Col>
                <Col sm="auto" className="ms-auto">
                </Col>
            </Row>
        </Card>
    );
};

PagosTittle.propTypes = {
    cargando: PropTypes.bool.isRequired
};

export default PagosTittle;
